var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shadows-wrapper"},[_c('div',{ref:"scrollContainer",staticClass:"scroll-container scrollbar-hide",style:({ height: _vm.height }),on:{"&scroll":function($event){return _vm.toggleShadow.apply(null, arguments)}}},[_vm._t("default"),_vm._v(" "),_c('span',{staticClass:"shadow-bottom",class:{ 'is-active': _vm.shadow.bottom }})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }